import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createSlots as _createSlots, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41a935e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-8" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "card-label" }, "Report Table")
  ])
], -1))
const _hoisted_3 = { class: "card-body py-0" }
const _hoisted_4 = ["id", "data-id"]
const _hoisted_5 = { class: "d-flex flex-center flex-wrap" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" More Detail ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-uppercase pb-3" }, "Summary", -1))
const _hoisted_8 = { class: "me-3" }
const _hoisted_9 = { class: "fw-bolder" }
const _hoisted_10 = { class: "fw-bolder" }
const _hoisted_11 = { class: "card px-5" }
const _hoisted_12 = { class: "card-header pt-6 flex-column" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "card-label" }, "Summary")
], -1))
const _hoisted_14 = { class: "card-subtitle row pt-6 px-3 gy-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fs-4" }, "Order report", -1))
const _hoisted_16 = { class: "col-lg-6 text-lg-end fs-4" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Date: ")
const _hoisted_18 = { class: "d-block d-lg-inline" }
const _hoisted_19 = { class: "card-title ms-3 pb-4" }
const _hoisted_20 = { class: "card-label fs-3" }
const _hoisted_21 = { class: "col-lg-6 text-lg-end" }
const _hoisted_22 = { class: "card-header pt-6 flex-column border-0" }
const _hoisted_23 = { class: "col-lg-6 text-lg-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrowseCard = _resolveComponent("BrowseCard")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BrowseCard, {
      modelValue: $setup.models,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.models) = $event)),
      onSearch: $setup.search
    }, null, 8, ["modelValue", "onSearch"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Datatable, {
          ref: "tableRef",
          loading: $setup.tableState.loading,
          "table-header": $setup.tableState.header,
          "table-data": $setup.tableState.tableData,
          total: $setup.tableState.total
        }, _createSlots({
          "cell-no": _withCtx(({ index }) => [
            _createTextVNode(_toDisplayString(index + 1 + _ctx.rowsPerPage * (_ctx.currentPage - 1)), 1)
          ]),
          "cell-checkedBox": _withCtx(({ row }) => [
            _createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: `checkbox${row.id}`,
              "data-id": `${row.id}`,
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSelected && _ctx.handleSelected(...args)))
            }, null, 40, _hoisted_4)
          ]),
          "cell-showStartDate": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString($setup.dateFormat(row.startDate, 'D/MM/YYYY')), 1)
          ]),
          "cell-showEndDate": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString($setup.dateFormat(row.endDate, 'D/MM/YYYY')), 1)
          ]),
          "cell-store": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.store?.name || '-'), 1)
          ]),
          "cell-status": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString($setup.mappedStatus[row.status]), 1)
          ]),
          "cell-showTotalPrice": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.price?.full ? $setup.numberFormat(row.price.full) : '-'), 1)
          ]),
          "cell-showNetPrice": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.price?.store ? $setup.numberFormat(row.commission.store) : '-'), 1)
          ]),
          "cell-showId": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(`XXX${row.id.slice(16).toUpperCase()}`), 1)
          ]),
          "cell-showCustomer": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.customer?.name || '-'), 1)
          ]),
          "cell-showCarBrand": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.car?.name || '-'), 1)
          ]),
          "cell-showServicePoint": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.servicePoint?.name || '-'), 1)
          ]),
          "cell-moreDetail": _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: `/sales-report/${row.id}`,
                class: "btn btn-primary custom-slim-btn text-nowrap"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _: 2
        }, [
          _renderList($setup.tableState.header.filter(
            (data) =>
              ![
                'moreDetail',
                'no',
                'showServicePoint',
                'showStartDate',
                'showEndDate',
                'showCarBrand',
                'showCustomer',
                'showTotalPrice',
                'showNetPrice',
                'showId',
                'store',
                'status',
                'checkedBox',
              ].includes(data.key)
          ), (item, i) => {
            return {
              name: `cell-${item.key}`,
              fn: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString(row[`${item.key}`]), 1)
              ])
            }
          }),
          false
            ? {
                name: "summary",
                fn: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _hoisted_7,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.summaryTemplate[0]?.contents || [], (summary, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "row px-3 h-40px"
                      }, [
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(summary.label) + ":", 1),
                          _createElementVNode("span", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString($setup.numberFormat(summary.key)), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              }
            : undefined
        ]), 1032, ["loading", "table-header", "table-data", "total"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("label", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString($setup.models.date?.length
              ? `${$setup.dateFormat($setup.models.date[0], 'DD/MM/YYYY')} - ${$setup.dateFormat(
                  $setup.models.date[1],
                  'DD/MM/YYYY'
                )}`
              : 'No Data'), 1)
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.summaryTemplate, (summary, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "card-header pt-6 flex-column"
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h1", _hoisted_20, _toDisplayString(summary.title), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.contents, (content, j) => {
            return (_openBlock(), _createElementBlock("div", {
              key: j,
              class: "row px-3 h-40px"
            }, [
              _createElementVNode("label", {
                class: _normalizeClass([j === summary.contents.length - 1 && 'fw-bolder', "col-lg-6 fs-5"])
              }, _toDisplayString(content.label), 3),
              _createElementVNode("label", _hoisted_21, _toDisplayString(content.key || '-'), 1)
            ]))
          }), 128))
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.totals, (total, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "row px-3 h-40px"
          }, [
            _createElementVNode("label", {
              class: _normalizeClass([i === $setup.totals.length - 1 && 'fw-bolder fs-4', "col-lg-6 fs-5"])
            }, _toDisplayString(total.label), 3),
            _createElementVNode("label", _hoisted_23, _toDisplayString(total.key || '-'), 1)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}